import { Plus, Trash } from '@phosphor-icons/react';

/**
 * Secção "Ficheiros do desafio" extraída de AdminDesafiosPage.
 * Render-only — todo o estado (lista de ficheiros, upload form) continua no orquestrador.
 */
export default function ChallengeFilesSection({ files, onOpenUpload, onDeleteFile }) {
  return (
    <div className="bg-white border border-brand-border rounded-2xl p-4 mb-5" data-testid="files-section">
      <div className="flex justify-between mb-3">
        <h3 className="font-heading font-medium text-xs text-brand-muted uppercase tracking-wider">Ficheiros do desafio</h3>
        <button onClick={onOpenUpload} className="text-xs text-brand-green flex items-center gap-1" data-testid="add-file-btn"><Plus size={12} /> Adicionar ficheiro</button>
      </div>
      {files.length === 0 ? <p className="text-xs text-brand-placeholder">Sem ficheiros. Adiciona PDFs, áudios, imagens ou vídeos programados por dia.</p> : (
        <ul className="space-y-1.5">
          {files.map(f => (
            <li key={f.id} className="flex items-center justify-between bg-brand-bg/40 rounded-xl px-3 py-2" data-testid={`file-${f.id}`}>
              <div className="flex-1 min-w-0">
                <p className="text-sm text-brand-text truncate">{f.title}</p>
                <p className="text-[10px] text-brand-muted">Dia {f.day} · {f.file_type} · {Math.round((f.size || 0) / 1024)} KB</p>
              </div>
              <button onClick={() => onDeleteFile(f.id)} className="text-brand-placeholder hover:text-red-500 p-1" data-testid={`del-file-${f.id}`}><Trash size={13} /></button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
